import React from 'react';
import Select from 'react-select';

const SubHeader = ({
  selectOptions = [],
  extraSelectOptions = [],
  searchValue,
  onSearchChange,
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  onFilter,

  // ✅ NEW PROP
  buttons = [],
}) => {
  const baseSelectStyles = {
    container: (base) => ({
      ...base,
      minWidth: 200,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        whiteSpace: 'nowrap',
        paddingBottom: 8,
        overflow: 'auto',
      }}
    >
      {Array.isArray(selectOptions) &&
        selectOptions.length > 0 &&
        selectOptions.map((selectItem, index) => (
          <div key={index} style={{ flexShrink: 0 }}>
            <Select
              options={
                Array.isArray(selectItem.options)
                  ? selectItem.options
                  : [selectItem.options]
              }
              onChange={selectItem.onChange}
              placeholder={selectItem.placeholder || 'Select option'}
              isClearable
              className="formControl"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={baseSelectStyles}
            />
          </div>
        ))}

      {Array.isArray(extraSelectOptions) &&
        extraSelectOptions.length > 0 &&
        extraSelectOptions.map((selectItem, index) => (
          <div key={`extra-${index}`} style={{ flexShrink: 0 }}>
            <Select
              options={
                Array.isArray(selectItem.options)
                  ? selectItem.options
                  : [selectItem.options]
              }
              onChange={selectItem.onChange}
              placeholder={selectItem.placeholder || 'Select filter'}
              isClearable
              className="formControl"
              isLoading={selectItem.isLoading}
              onMenuScrollToBottom={() =>
                selectItem.onScroll && selectItem.onScroll()
              }
              onInputChange={(v) =>
                selectItem.onSearch && selectItem.onSearch(v)
              }
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                ...baseSelectStyles,
                menuList: (base) => ({
                  ...base,
                  maxHeight: 200,
                }),
              }}
            />
          </div>
        ))}

      {onSearchChange && (
        <input
          type="text"
          value={searchValue || ''}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search..."
          className="form-control"
          style={{
            padding: '8px 12px',
            border: '1px solid #ccc',
            borderRadius: 6,
            maxWidth: 200,
            fontSize: 14,
            flexShrink: 0,
          }}
        />
      )}

      <input
        type="date"
        value={fromDate || ''}
        onChange={(e) => onFromDateChange && onFromDateChange(e.target.value)}
        className="form-control"
        style={{
          padding: '8px 12px',
          border: '1px solid #ccc',
          borderRadius: 6,
          maxWidth: 160,
          fontSize: 14,
          flexShrink: 0,
        }}
      />

      <input
        type="date"
        value={toDate || ''}
        onChange={(e) => onToDateChange && onToDateChange(e.target.value)}
        className="form-control"
        style={{
          padding: '8px 12px',
          border: '1px solid #ccc',
          borderRadius: 6,
          maxWidth: 160,
          fontSize: 14,
          flexShrink: 0,
        }}
      />

      <button onClick={onFilter} className="btn btn-primary">
        Filter
      </button>
      {Array.isArray(buttons) &&
        buttons.length > 0 &&
        buttons.map((btn, index) => (
          <button
            key={index}
            onClick={btn.onClick}
            className={`btn ${btn.className || 'btn-secondary'}`}
            disabled={btn.disabled}
          >
            {btn.title}
          </button>
        ))}
    </div>
  );
};

export { SubHeader };
